import { Link, SidebarDropdownMenuItem } from "@design-system/components";
import type { ConnectMenuItem } from "@spiriidk/connect-configs";
import React from "react";

import { SystemStatusItem } from "../system-status-item";

interface HelpMenuItemProps {
  item: ConnectMenuItem;
  label: string;
  onOpenDebugInfoDialog: () => void;
}

function HelpMenuLinkItem({ item, label }: HelpMenuItemProps) {
  const IconComponent = item.icon;

  if (!item.url) {
    return null;
  }

  return (
    <SidebarDropdownMenuItem asChild>
      <Link
        href={item.url}
        newTab
        data-track-name={item.id}
        data-track-context="help-menu"
      >
        {IconComponent && <IconComponent />}
        <span>{label}</span>
      </Link>
    </SidebarDropdownMenuItem>
  );
}

function HelpMenuDebugInfoItem({
  item,
  label,
  onOpenDebugInfoDialog,
}: HelpMenuItemProps) {
  const IconComponent = item.icon;

  return (
    <SidebarDropdownMenuItem
      onClick={onOpenDebugInfoDialog}
      data-track-name="debug-info"
      data-track-context="help-menu"
    >
      {IconComponent && <IconComponent />}
      <span>{label}</span>
    </SidebarDropdownMenuItem>
  );
}

function HelpMenuItem(props: HelpMenuItemProps) {
  if (props.item.id === "system-status") {
    return <SystemStatusItem />;
  }

  if (props.item.id === "debug-info") {
    return <HelpMenuDebugInfoItem {...props} />;
  }

  return <HelpMenuLinkItem {...props} />;
}

export { HelpMenuItem };
export type { HelpMenuItemProps };
